module.exports = __webpack_public_path__ + "static/media/grainger-logo-white.8e5ae52c.png";